import axios from '@/lib/axios'
import { buildAdminRequestConfig } from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { Inventory, UpdateInventoryInput } from './inventory.types'

/** Inventory requests are scoped to the organization. */
export interface InventoryOrganizationScope {
  organizationId: number | string
}

/** Query key entries; the scoped key builders always set the organization as a number. */
export interface InventoryIndexQueryKeyEntries {
  organizationId: number
}

/** Query functions read only the key. */
type InventoryQueryContext<TKey> = Pick<QueryFunctionContext<[TKey]>, 'queryKey'>

export async function getInventory({
  queryKey: [{ organizationId }],
}: InventoryQueryContext<InventoryIndexQueryKeyEntries>) {
  return (
    (await axios.get<Inventory>(
      '/products/inventory',
      buildAdminRequestConfig({ organizationId })
    )) || {
      data: [],
      meta: {},
    }
  )
}

/** Resolves to the refreshed inventory list. */
export async function updateInventory({
  organizationId,
  ...values
}: UpdateInventoryInput & InventoryOrganizationScope) {
  return axios.put<Inventory>(
    '/products/inventory',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}
